import React from 'react';
import { ToggletipWrapper, ToggletipPane } from '../styles';
import { useToggletipBehavior } from '../shared';

var Toggletip = function Toggletip(_ref) {
  var children = _ref.children,
      targetElement = _ref.targetElement,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'bottomRight' : _ref$position,
      className = _ref.className,
      dataTest = _ref['data-test'];

  var _useToggletipBehavior = useToggletipBehavior(targetElement),
      isToggletipShown = _useToggletipBehavior.isToggletipShown,
      onMouseLeaveWrapper = _useToggletipBehavior.onMouseLeaveWrapper,
      extendedTargetElement = _useToggletipBehavior.extendedTargetElement,
      wrapperRef = _useToggletipBehavior.wrapperRef;

  return /*#__PURE__*/React.createElement(ToggletipWrapper, {
    onMouseLeave: onMouseLeaveWrapper,
    className: className,
    ref: wrapperRef,
    "data-test": dataTest ? "".concat(dataTest, "-wrapper") : undefined
  }, extendedTargetElement, /*#__PURE__*/React.createElement(ToggletipPane, {
    isShown: isToggletipShown,
    position: position,
    role: "tooltip",
    "data-test": dataTest ? dataTest : undefined
  }, children));
};

export default Toggletip;